export const normalizeNumbers = (value: string): string => {
  return `${value}`.replace(/\D/g, '')
}
